<template>
  <!-- <keep-alive>
    <router-view />
  </keep-alive> -->
  <!-- <div class="footer_wrap">
    <a href="#/cooperation">发现音乐</a>
    <a href="#/enter">我的音乐</a>
    <a href="#/join">朋友</a>
    <a href="#/recruit">朋友</a>
  </div> -->
  <div class="top">
    <!-- 路由出口 → 匹配的组件所展示的位置 -->
    <router-view></router-view>
  </div>
</template>
<style></style>
